import { useQuery } from '@apollo/client';

import asBentoPage from 'common/bento/hoc/asBentoPage';
import SuspenseQuery from 'components/SuspenseQuery';
import Header from 'features/Onboarding/components/Header';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';

import Form from './components/Form';
import { GetCompanyNameDocument } from './graphql/queries/getCompanyName.gql';
import { CompanyNameSchema } from './libs/companyNameSchema';
import locales from './locales';

export interface CompanyNameProps {
  isSending: boolean;
  onSubmit: (values: CompanyNameSchema) => void;
  companyProfileId?: string;
}

const CompanyName = asBentoPage<CompanyNameProps>(
  ({ companyProfileId, isSending, Layout, onPrev, onSubmit }) => {
    const query = useQuery(GetCompanyNameDocument, {
      // not using skip as doesn't work well with display query (data returned is undefined, so spinner is always shown)
      variables: {
        companyProfileId: companyProfileId || '',
        includeCompany: Boolean(companyProfileId),
      },
    });

    return (
      <Layout nav={<OBNavigation onPrev={onPrev} />}>
        <Header description={locales.description} title={locales.title} />
        <SuspenseQuery query={query}>
          {(data) => (
            <Form
              formData={{
                legalName: data.viewer.company?.profile.legalName || '',
              }}
              isSending={isSending}
              onSubmit={onSubmit}
            />
          )}
        </SuspenseQuery>
      </Layout>
    );
  },
);

export default CompanyName;
